import {
	type ProjectType,
	PRODUCT_DISCOVERY_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants';
import {
	JIRA_SERVICE_MANAGEMENT_APP_NAME,
	JIRA_PRODUCT_DISCOVERY_APP_NAME,
} from '@atlassian/jira-project-settings-apps-common/src/consts';

export const getApplicationName = (projectType: ProjectType): string => {
	switch (projectType) {
		case SOFTWARE_PROJECT:
			return 'Jira';
		case SERVICE_DESK_PROJECT:
			return JIRA_SERVICE_MANAGEMENT_APP_NAME;
		case PRODUCT_DISCOVERY_PROJECT:
			return JIRA_PRODUCT_DISCOVERY_APP_NAME;
		default:
			throw new Error(`Unknown application type: ${projectType}`);
	}
};
